// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPanel from "./AdminPanel";
import StreamView from "./StreamView";
import DarkModeToggle from "./components/DarkModeToggle";

function App() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'transparent',
    }}>
      <BrowserRouter>
        <DarkModeToggle />
        <Routes>
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/*" element={<StreamView />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
